import React from 'react';
import { User, UserRole } from '../types';
import { UserCircle, LogOut } from 'lucide-react';
import { NotificationBell } from './NotificationBell';

interface HeaderProps {
  user: User;
  onSignOut?: () => void;
}

const roleLabels: Record<UserRole, string> = {
  collaborator: 'Colaborador',
  manager: 'Gestor',
  finance: 'Financeiro',
  governance: 'Governança',
  admin: 'Administrador',
  rh: 'Recursos Humanos',
  supplier: 'Fornecedor',
  prestador_pj: 'Prestador PJ',
  purchasing: 'Compras',
  it: 'TI',
  audit: 'Auditoria',
};

export const Header: React.FC<HeaderProps> = ({ user, onSignOut }) => {
  const handleLogoutClick = () => {
    if (onSignOut) onSignOut();
  };
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <h1 className="text-2xl font-bold text-gray-900">
            Plataforma de Gestão de Parceiros
          </h1>
          <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
            {roleLabels[user.role]}
          </span>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <UserCircle className="w-8 h-8 text-gray-600" />
            <div>
              <p className="text-sm font-medium text-gray-900">{user.name}</p>
              <p className="text-xs text-gray-500">{user.email}</p>
            </div>
          </div>
          <NotificationBell />
          <button
            className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            onClick={handleLogoutClick}
            title="Sair"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
};
